import type { PlaceholderSound } from "./types";

export const createSoundboardPlaceholder = (index: number): PlaceholderSound => ({
  id: `placeholder-${index}`,
  name: `Empty Slot ${index + 1}`,
  type: "placeholder",
});
